import { isBefore } from 'date-fns'
import { fromJS } from 'immutable'
import { createReducer } from 'redux-immutablejs'

import {
  FETCH_EAP_HPI_BANNER_STATE_FULFILLED,
  FETCH_EAP_HPI_BANNER_STATE_REJECTED,
  SET_EAP_HPI_BANNER_STATE_IS_LOADED,
} from './eapHpiBannerActions'

export const initialState = {
  isEapHpiBannerStateLoaded: false,
  isHomebaseBannerVisible: false,
  isAccountBannerVisible: false,
  expirationDate: undefined,
  flowAs: undefined,
  notificationType: undefined,
  providerLyraId: undefined,
  sessionType: undefined,
  sessionsRemaining: undefined,
  childLyraId: undefined,
  dependentName: undefined,
}

export default createReducer(fromJS(initialState), {
  [SET_EAP_HPI_BANNER_STATE_IS_LOADED]: ($$state: $TSFixMe) => {
    return $$state.merge({
      isEapHpiBannerStateLoaded: true,
    })
  },
  [FETCH_EAP_HPI_BANNER_STATE_FULFILLED]: ($$state: $TSFixMe, action: $TSFixMe) => {
    const stateUpdates = [{ isEapHpiBannerStateLoaded: true }]
    const expirationDate = action.data.expirationDate && new Date(action.data.expirationDate)
    const isBannerExpired = expirationDate && isBefore(expirationDate, new Date())
    if (!isBannerExpired && action.data.sessionsRemaining != null && action.data.sessionsRemaining <= 1) {
      stateUpdates.push(action.data)
    }
    return $$state.merge(...stateUpdates)
  },
  [FETCH_EAP_HPI_BANNER_STATE_REJECTED]: ($$state: $TSFixMe) => {
    return $$state.merge({
      ...initialState,
      isEapHpiBannerStateLoaded: true,
    })
  },
})
